<template>
  <div class="ag-slide view-slide" >
    <img src="../../assets/images/ag-analytics2.png"/>
    <div class="slide-text-part">
      <!-- <h3 v-on:click="select($event)">AG-ANALYTICS®</h3> -->
      <img src="../../assets/images/ag-analytics-logo.png">
      <span class="minimized-indicator"></span>
      <div class="clearfix"></div>
      <h4>FARM DATA MEETS BIG DATA.</h4>
      <p>The Ag-Analytics® platform brings farmers, universities, industry and government together with our combined research roots, long standing business relationships, and technology development. We aim to help our users make better management decisions, increase yield, and mitigate risk by understanding both.</p>
      <div class="text-center">
        <button>OPEN APP</button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import baseAppComponent from "./baseAppComponent.vue";

export default {
  extends: baseAppComponent,
  name: "AgAnalyticsComponent"
};
</script>

